import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BaseUrl from "./Baseurl/Api.js";
import Swal from "sweetalert2";

const Productdetailmain = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [productDetails, setProductDetails] = useState([]);
  const [productValue, setProductValue] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [thumbnailImages, setThumbnailImages] = useState([]);
  const [countNum, setCountNum] = useState(1);
  const [showFullDesc, setShowFullDesc] = useState(false);
  const [review, setReview] = useState({
    name: "",
    email: "",
    date: new Date().toISOString().split("T")[0],
    time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    orderStatus: "Pending",
    rating: 0,
    orderDetails: "",
  });
  const [hoverRating, setHoverRating] = useState(0);
  const [cartData, setCartData] = useState([]);

  const selectedProduct = productValue.find(inv => inv.id === selectedVariant);

  // Variant selection
  const handleVariantClick = (variantId) => {
    setSelectedVariant(variantId);
    setCountNum(1); // reset quantity when switching variant
    const variant = productValue.find(inv => inv.id === variantId);
    if (variant) {
      const newImageUrl = `https://dharajwebbackend.concentics.com/productimage/${variant.image}`;
      setMainImage(newImageUrl);
      setThumbnailImages([newImageUrl]);
    }
  };

  const goToCart = () => navigate("/cart");

  // Add to Cart
  const addToCart = async () => {
    if (!selectedVariant) {
      Swal.fire({
        icon: "warning",
        title: "Select Variant",
        text: "Please select a variant before adding to cart!",
      });
      return;
    }

    const variant = productValue.find((inv) => inv.id === selectedVariant);
    const product = productDetails.find((p) => id.includes(p.id.toString()));
    if (!variant || !product) return;

    const diviceIddata = localStorage.getItem("deviceId");
    const userid = localStorage.getItem("userId");

    const cartPayload = {
      cartImage: product.productImage,
      cartproductname: product.productName,
      cartprice: variant.price,
      proquantity: variant.proquantity || 1,
      qtycategory: variant.productmeasurement,
      totalamount: variant.price * countNum, // ✅ total amount calculation
      discount: variant.discount || 0,
      quantity: countNum,
      pid: product.id,
      uid: userid,
      diviceId: diviceIddata,
    };

    try {
      const response = await fetch(
        "https://dharajwebbackend.concentics.com/api/get_cart",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cartPayload),
        }
      );

      const data = await response.json();

      if (response.ok && (data.status === "success" || data.message.includes("successfully"))) {
        Swal.fire({
          icon: "success",
          title: "Added to Cart!",
          text: "Product added successfully.",
          height: "auto",
          padding: '3em',
          confirmButtonColor: "#185E37",
        }).then(() => {
          goToCart();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.message || "Failed to add to cart",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  };

  // Buy Now
  const handleBuyNow = () => {
    if (!selectedVariant) {
      Swal.fire({
        icon: "warning",
        title: "Select Variant",
        text: "Please select a variant before buying!",
      });
      return;
    }

    const variant = productValue.find((inv) => inv.id === selectedVariant);
    const product = productDetails.find((p) => id.includes(p.id.toString()));
    if (!variant || !product) return;

    navigate("/CheckOut/:status", {
      state: {
        productId: product.id,
        productName: product.productName,
        selectedVariant: variant,
        quantity: countNum,
        price: variant.price * countNum, // ✅ total amount for checkout
        image: mainImage,
      },
    });
  };

  // Quantity
  const addQuantity = () => {
    if (selectedProduct && countNum < selectedProduct.inventory) {
      setCountNum(prev => prev + 1);
    } else {
      Swal.fire({
        icon: "info",
        title: "Stock Limit",
        text: "Maximum available stock reached.",
      });
    }
  };

  const subQuantity = () => {
    if (countNum > 1) setCountNum(prev => prev - 1);
  };

  // Reviews
  const handleReviewChange = (e) => {
    const { name, value } = e.target;
    setReview(prev => ({ ...prev, [name]: value }));
  };

  const handleRatingClick = (value) => {
    setReview(prev => ({ ...prev, rating: value }));
  };

  const submitReview = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "Review Submitted",
      text: "Your review has been submitted successfully!",
    });
    setReview({
      name: "",
      email: "",
      date: new Date().toISOString().split("T")[0],
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      orderStatus: "Pending",
      rating: 0,
      orderDetails: "",
    });
  };

  // Fetch product & inventory data
  useEffect(() => {
    BaseUrl.get("/api/get_allproduct")
      .then(res => {
        if (res.data.status === "success") {
          setProductDetails(res.data.product);
          const product = res.data.product.find(p => id.includes(p.id.toString()));
          if (product) {
            const mainImg = `https://dharajwebbackend.concentics.com/productimage/${product.productImage}`;
            setMainImage(mainImg);

            const thumbs = [];
            if (product.productImage) thumbs.push(mainImg);
            if (product.multiimage)
              thumbs.push(`https://dharajwebbackend.concentics.com/productimage/${product.multiimage}`);
            setThumbnailImages(thumbs);
          }
        }
      })
      .catch(err => console.error("Product fetch error:", err));

    BaseUrl.get("/api/get_inventory")
      .then(res => {
        if (res.data.status === "success") setProductValue(res.data.inventory);
      })
      .catch(err => console.error("Inventory fetch error:", err));

    fetch("https://dharajwebbackend.concentics.com/api/get_cart")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") setCartData(data.cart);
      })
      .catch(err => console.error("Cart fetch error:", err));
  }, [id]);

  return (
    <section className="pd-section">
      <div className="container">
        {productDetails.filter(p => id.includes(p.id.toString())).map(product => (
          <div className="pd-row" key={product.id}>
            <div className="pd-left">
              <div className="image-area">
                <div className="thumbnails">
                  {productValue.filter(inv => id.includes(inv.pid.toString())).map(inv => {
                    const imgUrl = `https://dharajwebbackend.concentics.com/productimage/${inv.image}`;
                    return (
                      <img
                        key={inv.id}
                        src={imgUrl}
                        alt="Variant"
                        className={`thumb ${selectedVariant === inv.id ? "active" : ""}`}
                        onClick={() => handleVariantClick(inv.id)}
                      />
                    );
                  })}
                </div>
                <div className="main-image">
                  <img src={mainImage} alt={product.productName} onError={(e) => (e.target.src = "/placeholder.jpg")} />
                </div>
              </div>
            </div>

            <div className="pd-right">
              <h1 className="pd-title">{product.productName}</h1>
              <div className="pd-stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`bi bi-star${i < 4 ? "-fill" : "-half"} text-warning fs-lg`}></i>
                ))}
              </div>

              <p className="pd-variant-label fs-lg">Select Variant</p>
              <div className="pd-variants">
                {productValue.filter(inv => id.includes(inv.pid.toString())).map(inv => {
                  const active = selectedVariant === inv.id;
                  const hasDiscount = inv.discount && inv.discount !== "0";
                  return (
                    <button key={inv.id} className={`variant-btn ${active ? "active" : ""}`} onClick={() => handleVariantClick(inv.id)}>
                      <span className="d-flex gap-3 fs-md">
                        {hasDiscount && <span className="off">{inv.discount}% OFF</span>}
                        {inv.productmeasurement} {inv.producttype}
                      </span>
                      <div className="price">
                        ₹{inv.price * countNum} {hasDiscount && <del>₹{inv.price}</del>}
                      </div>
                    </button>
                  );
                })}
              </div>

              <div className="pd-desc">
                {showFullDesc ? product.description : product.description.slice(0, 150) + "..."}
                <span className="toggle" onClick={() => setShowFullDesc(!showFullDesc)}>
                  {showFullDesc ? " Show Less" : " Read More"}
                </span>
              </div>

              <div className="quantity-section">
                <button className="qty-btn" onClick={subQuantity}>–</button>
                <span className="qty-value">{countNum}</span>
                <button className="qty-btn" onClick={addQuantity}>+</button>
              </div>

              {selectedProduct && (
                <span className="ms-2 text-muted" style={{ fontSize: "14px" }}>
                  (Available: {selectedProduct.inventory} In Stock)
                </span>
              )}

              <div className="total-amount">
                <strong>Total: ₹{selectedProduct ? selectedProduct.price * countNum : 0}</strong>
              </div>

              <div className="pd-buttons">
                <button className="btn-cart" onClick={addToCart}>
                  <i className="bi bi-cart2"></i> Add to Cart
                </button>
                <button className="btn-buy" onClick={handleBuyNow}>Buy it Now</button>
              </div>
            </div>
          </div>
        ))}

        {/* Review Form */}
        <div className="review-form-container">
          <h2 className="review-title">Customer Review</h2>
          <form onSubmit={submitReview} className="review-form">
            <div className="form-row">
              <div className="form-group">
                <label>Name</label>
                <input type="text" name="name" value={review.name} onChange={handleReviewChange} required />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" value={review.email} onChange={handleReviewChange} required />
              </div>
            </div>
            <div className="form-group">
              <label>Rating</label>
              <div className="rating-stars">
                {[1, 2, 3, 4, 5].map(star => (
                  <span key={star} onClick={() => handleRatingClick(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} style={{ color: (hoverRating || review.rating) >= star ? "#ffc107" : "#ccc" }}>★</span>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label>Order Details</label>
              <textarea name="orderDetails" value={review.orderDetails} onChange={handleReviewChange} rows={4} required />
            </div>
            <div className="form-footer">
              <button type="submit" className="btn-submit">Submit Review</button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
  .pd-row {
    display: flex;
    gap: 40px;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .pd-left {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .image-area {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    max-width: 600px;
    gap: 15px;
  }

  .main-image {
    flex: 1;
    width: 400px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f8f8;
    border-radius: 12px;
    overflow: hidden;
  }

  .main-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .thumbnails {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    max-height: 500px;
    padding-right: 5px;
  }

  .thumb {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    cursor: pointer;
    object-fit: cover;
    border: 2px solid transparent;
    transition: 0.2s;
  }

  .thumb:hover {
    border-color: #999;
  }

  .thumb.active {
    border-color: #000;
  }
    /* ✅ Quantity Selector */
        .quantity-section {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin: 25px 0 20px;
          background: #fff;
          padding: 8px 14px;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          user-select: none;
        }

        .qty-btn {
          width: 40px;
          height: 40px;
          font-size: 22px;
          font-weight: 600;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          background: linear-gradient(135deg, #185E37, #3CB371);
          color: #fff;
          transition: all 0.2s ease;
        }

        .qty-btn:hover {
          transform: scale(1.05);
          background: linear-gradient(135deg, #3CB371, #185E37);
        }

        .qty-value {
          width: 45px;
          text-align: center;
          font-size: 18px;
          font-weight: 600;
          color: #185E37;
        }
          

  /* ✅ Mobile Responsive */
  @media (max-width: 768px) {
    .pd-row {
      flex-direction: column;
      align-items: center;
    }

    .image-area {
      flex-direction: column;
      align-items: center;
    }

    .main-image {
      width: 100%;
      height: auto;
      max-width: 400px;
    }

    /* ✅ Move thumbnails below main image */
    .thumbnails {
      flex-direction: row;
      justify-content: center;
      align-items: center;
      overflow-x: auto;
      overflow-y: hidden;
      max-height: none;
      margin-top: 15px;
      padding-bottom: 5px;
    }

    .thumb {
      width: 60px;
      height: 60px;
    }
  }

  /* Review Form */
  .review-form-container {
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    padding: 40px 30px;
    margin-top: 60px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  }

  .review-title {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 25px;
    color: #222;
    text-align: center;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
  }

  .review-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .form-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .form-group {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .form-group label {
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 15px;
    transition: all 0.2s ease;
    outline: none;
  }

  .form-group input:focus,
  .form-group select:focus,
  .form-group textarea:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0,123,255,0.15);
  }

  .rating-stars {
    display: flex;
    gap: 8px;
    font-size: 32px;
    cursor: pointer;
    transition: color 0.2s ease;
    justify-content: flex-start;
  }

  .btn-submit {
    background: linear-gradient(90deg,#298b31, #298b31);
    color: #fff;
    border: none;
    padding: 12px 25px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.2s ease;
    width: 200px;
    align-self: center;
  }

  .btn-submit:hover {
    background: linear-gradient(90deg,#185E37, #185E37);
    transform: translateY(-2px);
  }

  .form-footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  @media (max-width: 768px) {
    .review-form-container {
      padding: 25px 20px;
    }

    .form-row {
      flex-direction: column;
    }
    .image-area {
        flex-direction: column-reverse;
        align-items: center;
      }

    .btn-submit {
      width: 100%;
    }
  }
`}</style>
    </section>
  );
};

export default Productdetailmain;
